export enum UserPersonas {
  Customer = 'Customer',
  Dealer = 'Dealer',
}

export enum UserRoles {
  ADMIN = 'Admin',
  STANDARD = 'Standart',
}
